import * as React from 'react';
import { Input, Select, Checkbox, Row, Col } from 'antd';
import CountrySelect from '../../../../components/Others/CountrySelect';

import { FormItem } from '../../../../components/Form';

export interface IValuesSettingsColProps {
  domain: string;
  customer: GQL.ICustomer;
  onChange: Function;
}

export interface IValuesSettingsColState {
  valueIndex?: any;
}

export default class ValuesSettingsCol extends React.Component<IValuesSettingsColProps, IValuesSettingsColState> {

  public constructor(props: IValuesSettingsColProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    const { customer } = this.props;

    return (
      <>
        <h3>Billing information</h3>
        <FormItem label={'Street address'} required={true}>
          <Input
            name={'invoiceAddressLine1'}
            placeholder="Street address"
            value={customer.invoiceAddressLine1 || undefined}
            required={true}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Address line 2'}>
          <Input
            name={'invoiceAddressLine2'}
            placeholder="Address line 2"
            value={customer.invoiceAddressLine2 || undefined}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <Row gutter={10}>
          <Col md={16}>
            <FormItem label={'City'} required={true}>
              <Input
                name={'invoiceCity'}
                placeholder="City"
                value={customer.invoiceCity || undefined}
                required={true}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
          </Col>
          <Col md={8}>
            <FormItem label={'Zip'} required={true}>
              <Input
                name={'invoiceZip'}
                placeholder="Zip"
                value={customer.invoiceZip || undefined}
                required={true}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
          </Col>
        </Row>
        <FormItem label={'County / State'}>
          <Input
            name={'invoiceCountyState'}
            placeholder="County / State"
            value={customer.invoiceCountyState || undefined}
            onChange={e => this.props.onChange(e)}
          />
        </FormItem>
        <FormItem label={'Country'} required={true}>
          <CountrySelect
            name={'invoiceCountry'}
            value={customer.invoiceCountry || ''}
            onChange={(e: any, country: GQL.ICountry) => this.props.onChange({ target: { name: 'invoiceCountry', value: country.name } })}
          />
        </FormItem>

        <h3 style={{ marginTop: 20 }}>Delivery information</h3>
        <FormItem>
          <Checkbox
            name={'anotherDeliveryAddress'}
            checked={customer.anotherDeliveryAddress !== null && customer.anotherDeliveryAddress !== undefined ? customer.anotherDeliveryAddress : false}
            onChange={e => this.props.onChange(e)}
          >
            Another delivery address
          </Checkbox>
        </FormItem>

        {customer.anotherDeliveryAddress &&
          <React.Fragment>
            <FormItem label={'Street address'} required={true}>
              <Input
                name={'deliveryAddressLine1'}
                placeholder="Street address"
                value={customer.deliveryAddressLine1 || undefined}
                required={true}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
            <FormItem label={'Address line 2'}>
              <Input
                name={'deliveryAddressLine2'}
                placeholder="Address line 2"
                value={customer.deliveryAddressLine2 || undefined}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
            <Row gutter={10}>
              <Col md={16}>
                <FormItem label={'City'} required={true}>
                  <Input
                    name={'deliveryCity'}
                    placeholder="City"
                    value={customer.deliveryCity || undefined}
                    required={true}
                    onChange={e => this.props.onChange(e)}
                  />
                </FormItem>
              </Col>
              <Col md={8}>
                <FormItem label={'Zip'} required={true}>
                  <Input
                    name={'deliveryZip'}
                    placeholder="Zip"
                    value={customer.deliveryZip || undefined}
                    required={true}
                    onChange={e => this.props.onChange(e)}
                  />
                </FormItem>
              </Col>
            </Row>
            <FormItem label={'County / State'}>
              <Input
                name={'deliveryCountyState'}
                placeholder="County / State"
                value={customer.deliveryCountyState || undefined}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
            <FormItem label={'Country'} required={true}>
              <CountrySelect
                name={'deliveryCountry'}
                value={customer.deliveryCountry || ''}
                onChange={(e: any, country: GQL.ICountry) => this.props.onChange({ target: { name: 'deliveryCountry', value: country.name } })}
              />
            </FormItem>
          </React.Fragment>}

        <h3 style={{ marginTop: 20 }}>Company</h3>
        <FormItem>
          <Checkbox
            name={'companyInformation'}
            checked={customer.companyInformation !== null && customer.companyInformation !== undefined ? customer.companyInformation : false}
            onChange={e => this.props.onChange(e)}
          >
            Company information
          </Checkbox>
        </FormItem>

        {customer.companyInformation &&
          <React.Fragment>
            <FormItem label={'Company name'} required={customer.companyInformation}>
              <Input
                name={'companyName'}
                placeholder="Company name"
                value={customer.companyName || undefined}
                required={customer.companyInformation}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
            <FormItem label={'Registration No.'}>
              <Input
                name={'companyRegistrationNumber'}
                placeholder="Registration No."
                value={customer.companyRegistrationNumber || undefined}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
            <FormItem label={'Vat No.'} required={customer.companyInformation}>
              <Input
                name={'companyVatNumber'}
                placeholder="Vat No."
                value={customer.companyVatNumber || undefined}
                required={false}
                onChange={e => this.props.onChange(e)}
              />
            </FormItem>
          </React.Fragment>}
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Customers/CustomerDetail/components/Values.tsx